/* CATERINA DIAMOND · Trang chủ v7 — header trong suốt ở đầu trang, xuất hiện khi cuộn, băng sản phẩm có mũi tên,
   phim Mai Hoa (bản dọc cho điện thoại, nút dừng/bật tiếng); trang /pages/nhat-ky-anh — ảnh mở như cửa sổ, parallax,
   hộp xem ảnh lớn. Không phụ thuộc thư viện ngoài. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var hero = d.querySelector('.cdh-hero');
  if (!d.querySelector('.cdh')) { html.classList.remove('cdh-top'); return; }
  window.cdhReady = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || d).querySelectorAll(sel), fn); }

  /* 1. header trong suốt: đo chiều cao header để ảnh bìa lùi lên dưới header; bỏ trong suốt khi rời đầu trang */
  var hdr = d.getElementById('shopify-section-header-inline');
  function measure() { if (hdr && hero) html.style.setProperty('--cdh-hh', hdr.offsetHeight + 'px'); }
  function onScroll() { html.classList.toggle('cdh-top', !!hero && window.scrollY < 12); }
  measure(); onScroll();
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  if (hero) requestAnimationFrame(function () { hero.classList.add('is-in'); });

  /* 2. xuất hiện khi cuộn */
  if (!('IntersectionObserver' in window) || reduce) { each('.cdh [data-rv]', function (e) { e.classList.add('is-in'); }); }
  else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    each('.cdh [data-rv]', function (e) { io.observe(e); });
  }

  /* 3. băng sản phẩm: mũi tên trượt đúng một ô */
  each('[data-rail]', function (r) {
    var track = r.querySelector('.cdh-rail__track');
    var prev = d.querySelector('[data-rail-prev="' + r.id + '"]'), next = d.querySelector('[data-rail-next="' + r.id + '"]');
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 12 : 300; }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });

  /* 4. phim: chỉ tải và phát khi cuộn tới (tiết kiệm dữ liệu), bản dọc trên điện thoại, dừng/phát, bật tiếng */
  var v = d.querySelector('.cdh-film video');
  if (v) {
    var bp = d.querySelector('[data-film-play]'), bm = d.querySelector('[data-film-mute]');
    var PAUSE = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M4 2v10M10 2v10"/></svg>', PLAY = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M4 2l8 5-8 5z"/></svg>';
    /* cả hai bản phim mở đầu bằng ~2 giây màn đen chữ "START": bắt đầu từ giây 2 và khi lặp cũng quay về giây 2 */
    var START = 2.1, primed = false, userPaused = false;
    v.loop = false;
    v.addEventListener('ended', function () { v.currentTime = START; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    v.addEventListener('loadedmetadata', function () { if (v.currentTime < START) v.currentTime = START; });
    function prime() {
      if (primed) return; primed = true;
      try {
        var s = v.querySelector('source'), src = s.getAttribute('src');
        if (window.matchMedia('(max-width: 699px) and (orientation: portrait)').matches && v.getAttribute('data-portrait')) src = v.getAttribute('data-portrait');
        s.setAttribute('src', src.split('#')[0] + '#t=' + START);
        v.load();
      } catch (e) {}
    }
    function play() {
      prime(); var p = v.play(); if (p && p.catch) p.catch(function () {});
      if (bp) { bp.innerHTML = PAUSE; bp.setAttribute('aria-label', 'Tạm dừng phim'); }
    }
    function pause() {
      v.pause(); if (bp) { bp.innerHTML = PLAY; bp.setAttribute('aria-label', 'Phát phim'); }
    }
    if (bp) bp.addEventListener('click', function () { if (v.paused) { userPaused = false; play(); } else { userPaused = true; pause(); } });
    if (bm) bm.addEventListener('click', function () {
      v.muted = !v.muted; bm.setAttribute('aria-label', v.muted ? 'Bật tiếng' : 'Tắt tiếng'); bm.style.opacity = v.muted ? '1' : '.6';
    });
    if (!reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { if (!userPaused) play(); } else if (!v.paused) { pause(); } });
      }, { threshold: 0.35 }).observe(v);
    }
  }

  /* 5. phim sự kiện Thu Hà Nội: 3 video dọc, chỉ tải khi cuộn tới và chỉ phát video đang thấy rõ
     (điện thoại vuốt ngang: video ra khỏi màn hình thì dừng). Giảm chuyển động: giữ ảnh poster. */
  /* 29/09: cùng cơ chế cho các video lặp ngắn khác (ô Quỳnh Anh mở hộp quà, ô phim trên trang Nhật ký ảnh): video[data-loop] */
  var reels = d.querySelectorAll('.cdh-reel video, .cdh video[data-loop]');
  if (reels.length && !reduce && 'IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var rv = e.target;
        if (e.intersectionRatio >= 0.55) {
          if (!rv.getAttribute('src') && rv.getAttribute('data-src')) rv.setAttribute('src', rv.getAttribute('data-src'));
          var p = rv.play(); if (p && p.catch) p.catch(function () {});
        } else if (!rv.paused) { rv.pause(); }
      });
    }, { threshold: [0, 0.55] });
    Array.prototype.forEach.call(reels, function (rv) { ro.observe(rv); });
  }

  /* 6. trang Nhật ký ảnh: khung [data-jr] mở như cửa sổ khi cuộn tới (chỉ khi ảnh đã tải), ảnh trôi chậm hơn trang
     (parallax), biên độ 2.5% chiều cao khung (ảnh đã phóng 1.06 nên không lộ mép); chỉ tính ảnh gần màn hình. Giảm chuyển động: tắt. */
  var jw = d.querySelectorAll('.cdh [data-jr]');
  var jopen = function (w) { w.classList.add('is-in'); };
  if (reduce || !('IntersectionObserver' in window)) { Array.prototype.forEach.call(jw, jopen); }
  else {
    var wo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        wo.unobserve(e.target);
        var w = e.target, im = w.querySelector('img');
        if (!im || (im.complete && im.naturalWidth)) { jopen(w); return; }
        im.addEventListener('load', function () { jopen(w); }, { once: true });
        im.addEventListener('error', function () { jopen(w); }, { once: true });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    Array.prototype.forEach.call(jw, function (w) { wo.observe(w); });
  }
  var jr = d.querySelectorAll('.cdh [data-jr] img');
  if (jr.length && !reduce && 'IntersectionObserver' in window) {
    var live = [], queued = false;
    var drift = function () {
      queued = false;
      var vh = window.innerHeight;
      live.forEach(function (im) {
        var r = im.parentNode.getBoundingClientRect();
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        im.style.setProperty('--py', (-p * r.height * 0.025).toFixed(1) + 'px');
      });
    };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(drift); } };
    var po = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var i = live.indexOf(e.target);
        if (e.isIntersecting && i < 0) live.push(e.target);
        if (!e.isIntersecting && i >= 0) live.splice(i, 1);
      });
      queue();
    }, { rootMargin: '15% 0px' });
    Array.prototype.forEach.call(jr, function (im) { po.observe(im); });
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
  }

  /* 7. hộp xem ảnh lớn cho trang Nhật ký ảnh: bấm ảnh, ←/→, Esc, vuốt ngang trên điện thoại, bấm nền để đóng.
     Địa chỉ #anh-<mã> mở thẳng đúng ảnh (hàng ảnh vuông trên trang chủ dẫn tới đây); đóng hộp thì trang đứng ở ảnh đó.
     Không có JS hoặc trình duyệt thiếu <dialog>: liên kết mở tệp ảnh gốc. */
  var shots = Array.prototype.slice.call(d.querySelectorAll('.cdg [data-lb]'));
  if (shots.length && window.HTMLDialogElement && typeof d.createElement('dialog').showModal === 'function') {
    var ico = function (p) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + p + '</svg>'; };
    var lb, stage, pic, capSet, capTxt, count, cur = -1, back = null, closing = 0;
    var two = function (n) { return (n < 10 ? '0' : '') + n; };
    /* chọn bề ngang ảnh theo màn hình (bước 200px, tối đa 2000px — ảnh gốc 1334–1600px, Shopify không phóng to) */
    var sized = function (a) {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.min(2000, Math.ceil(Math.min(window.innerWidth, window.innerHeight * 0.68) * dpr / 200) * 200);
      return a.getAttribute('href').replace(/([?&]width=)\d+/, '$1' + w);
    };
    var build = function () {
      lb = d.createElement('dialog');
      lb.className = 'cdg-lb';
      lb.setAttribute('aria-label', 'Xem ảnh lớn');
      lb.innerHTML = '<div class="cdg-lb__stage"><img alt="" decoding="async"></div>' +
        '<div class="cdg-lb__bar"><p class="cdg-lb__cap"><b></b><span></span></p><span class="cdg-lb__count" aria-live="polite"></span></div>' +
        '<button type="button" class="cdg-lb__close" aria-label="Đóng" autofocus>' + ico('<path d="M5 5l14 14M19 5L5 19"/>') + '</button>' +
        '<button type="button" class="cdg-lb__prev" aria-label="Ảnh trước">' + ico('<path d="M15 5l-7 7 7 7"/>') + '</button>' +
        '<button type="button" class="cdg-lb__next" aria-label="Ảnh sau">' + ico('<path d="M9 5l7 7-7 7"/>') + '</button>';
      d.body.appendChild(lb);
      stage = lb.querySelector('.cdg-lb__stage'); pic = stage.querySelector('img');
      capSet = lb.querySelector('.cdg-lb__cap b'); capTxt = lb.querySelector('.cdg-lb__cap span'); count = lb.querySelector('.cdg-lb__count');
      pic.addEventListener('load', function () { pic.classList.add('is-ready'); });
      lb.querySelector('.cdg-lb__close').addEventListener('click', hide);
      lb.querySelector('.cdg-lb__prev').addEventListener('click', function () { go(cur - 1); });
      lb.querySelector('.cdg-lb__next').addEventListener('click', function () { go(cur + 1); });
      lb.addEventListener('cancel', function (e) { e.preventDefault(); hide(); });
      /* trình duyệt có thể tự đóng hộp (Esc lặp lại) mà không qua hide(): vẫn trả lại cuộn trang và địa chỉ */
      lb.addEventListener('close', function () {
        lb.classList.remove('is-open'); html.classList.remove('cdg-lb-on');
        if (location.hash) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === stage) hide(); });
      var x0 = null, y0 = 0;
      lb.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; } }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.3) go(dx < 0 ? cur + 1 : cur - 1);
        else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.5) hide();
      }, { passive: true });
    };
    var go = function (i) {
      var n = shots.length; i = (i % n + n) % n;
      if (i === cur) return;
      cur = i;
      var a = shots[i], im = a.querySelector('img');
      /* ẩn ngay ảnh cũ (không chạy hiệu ứng mờ dần) rồi mới đổi nguồn, để ảnh mới hiện dần khi tải xong */
      pic.style.transition = 'none';
      pic.classList.remove('is-ready');
      void pic.offsetWidth;
      pic.style.transition = '';
      pic.alt = im ? im.alt : '';
      pic.src = sized(a);
      if (pic.complete && pic.naturalWidth) pic.classList.add('is-ready');
      capSet.textContent = a.getAttribute('data-set') || '';
      capTxt.textContent = a.getAttribute('data-cap') || '';
      count.textContent = two(i + 1) + ' / ' + two(n);
      [i + 1, i - 1].forEach(function (k) { (new Image()).src = sized(shots[(k % n + n) % n]); });
      try { history.replaceState(null, '', '#' + a.id); } catch (e) {}
    };
    var show = function (i) {
      if (!lb) build();
      clearTimeout(closing);
      back = d.activeElement;
      cur = -1; go(i);
      if (!lb.open) lb.showModal();
      html.classList.add('cdg-lb-on');
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
    };
    var hide = function () {
      if (!lb || !lb.open) return;
      var a = shots[cur];
      lb.classList.remove('is-open');
      html.classList.remove('cdg-lb-on');
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      closing = setTimeout(function () {
        lb.close();
        if (a) {
          var r = a.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) a.scrollIntoView({ block: 'center' });
          try { a.focus({ preventScroll: true }); } catch (e) { a.focus(); }
        } else if (back && back.focus) { back.focus(); }
      }, reduce ? 0 : 300);
    };
    shots.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault(); show(i);
      });
    });
    var openHash = function () {
      var id = decodeURIComponent((location.hash || '').slice(1));
      var k = id ? shots.indexOf(d.getElementById(id)) : -1;
      if (k >= 0) show(k);
    };
    openHash();
    window.addEventListener('hashchange', openHash);
  }

  /* 8. xem video đầy đủ có tiếng: nút [data-film-open] (ô Quỳnh Anh mở hộp quà, phim "Ánh sáng trên da") mở hộp video
     toàn màn hình. Bản lặp ngắn trong ô vẫn tắt tiếng; bản đầy đủ chỉ tải khi bấm. Esc, nút đóng hoặc bấm nền để đóng. */
  var fo = d.querySelectorAll('[data-film-open]');
  if (fo.length && window.HTMLDialogElement && typeof d.createElement('dialog').showModal === 'function') {
    var vd = null, vv, vt, vback = null, vtimer = 0;
    var vend = function () {
      vv.pause(); vv.removeAttribute('src'); try { vv.load(); } catch (e) {}
      html.classList.remove('cdh-vd-on'); vd.classList.remove('is-open');
    };
    var vclose = function () {
      if (!vd || !vd.open) return;
      vv.pause(); vd.classList.remove('is-open'); html.classList.remove('cdh-vd-on');
      clearTimeout(vtimer);
      vtimer = setTimeout(function () { vd.close(); if (vback && vback.focus) vback.focus(); }, reduce ? 0 : 260);
    };
    var vbuild = function () {
      vd = d.createElement('dialog');
      vd.className = 'cdh-vd';
      vd.setAttribute('aria-label', 'Xem video');
      vd.innerHTML = '<video controls playsinline preload="none"></video><p class="cdh-vd__title"></p>' +
        '<button type="button" class="cdh-vd__close" aria-label="Đóng" autofocus><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>';
      d.body.appendChild(vd);
      vv = vd.querySelector('video'); vt = vd.querySelector('.cdh-vd__title');
      vd.querySelector('.cdh-vd__close').addEventListener('click', vclose);
      vd.addEventListener('cancel', function (e) { e.preventDefault(); vclose(); });
      vd.addEventListener('click', function (e) { if (e.target === vd) vclose(); });
      vd.addEventListener('close', vend);
    };
    Array.prototype.forEach.call(fo, function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (!vd) vbuild();
        clearTimeout(vtimer);
        vback = b;
        vv.src = b.getAttribute('data-film-open');
        /* ảnh bìa tạm = ảnh bìa của bản lặp cùng ô, hiện trong lúc bản đầy đủ đang tải */
        var lp = b.parentNode && b.parentNode.querySelector('video[poster]');
        if (lp) vv.setAttribute('poster', lp.getAttribute('poster')); else vv.removeAttribute('poster');
        vt.textContent = b.getAttribute('data-film-title') || '';
        if (!vd.open) vd.showModal();
        html.classList.add('cdh-vd-on');
        requestAnimationFrame(function () { vd.classList.add('is-open'); });
        var p = vv.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }
})();
